export const environment = {
  production: true,
  apiUrl: 'https://api.muzrus.com',
  staticUrl: 'https://api.muzrus.com',
  domainUrl: 'https://muzrus.com'
};
